module.exports = __webpack_public_path__ + "img/744.2f05a325.jpg";